/* eslint-disable @typescript-eslint/naming-convention */
import antdData from 'antd/lib/locale-provider/en_US';

export const enUS = Object.assign(
  { antdData: antdData },
  {

  }
);

export default enUS;
